module.exports = __webpack_public_path__ + "img/facebook_icon_black.9b8839c3.svg";